import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Bot, RefreshCw, Mail, CalendarClock, Search, Lightbulb, PhoneCall } from "lucide-react";

const TYPE_META = {
    stale_lead_alert: { label: "Cliente da ricontattare", icon: <PhoneCall size={13} />, cls: "border-amber-700/40 text-amber-300 bg-amber-900/20" },
    auto_email: { label: "Email automatica", icon: <Mail size={13} />, cls: "border-gold/40 text-gold bg-gold/10" },
    appointment_confirmed: { label: "Appuntamento confermato", icon: <CalendarClock size={13} />, cls: "border-green-700/40 text-green-300 bg-green-900/20" },
    external_match_alert: { label: "Match portali esterni", icon: <Search size={13} />, cls: "border-blue-700/40 text-blue-300 bg-blue-900/20" },
    priority_suggestion: { label: "Suggerimento commerciale", icon: <Lightbulb size={13} />, cls: "border-purple-700/40 text-purple-300 bg-purple-900/20" },
};

export const AdminAiActions = () => {
    const [data, setData] = useState(null);
    const [filter, setFilter] = useState("all");

    const load = () => api.get("/admin/ai-actions").then((r) => setData(r.data)).catch((e) => console.error(e));
    useEffect(() => { load(); }, []);

    if (!data) return <div className="text-ink-400">Caricamento...</div>;
    const items = filter === "all" ? (data.items || []) : (data.items || []).filter((i) => i.action_type === filter);

    return (
        <div data-testid="admin-ai-actions-tab" className="space-y-6">
            <div className="border border-white/10 p-6 bg-ink-900/40">
                <div className="flex items-center justify-between flex-wrap gap-3">
                    <div className="flex items-center gap-3">
                        <Bot size={20} className="text-gold" />
                        <div>
                            <h2 className="font-serif text-2xl text-ink-50">Azioni automatiche AI</h2>
                            <p className="text-xs text-ink-400 mt-1">{data.total} azioni registrate · ogni azione eseguita autonomamente dall&apos;assistente è tracciata qui con data, ora, tipo e agenzia.</p>
                            {data.pii_redacted && (
                                <p data-testid="ai-actions-privacy-notice" className="text-[10px] text-amber-300 mt-2 flex items-center gap-1.5">
                                    <span className="inline-block w-1.5 h-1.5 bg-amber-400 rounded-full" />
                                    GDPR: email e numeri di telefono dei clienti sono mascherati. I dettagli integrali sono visibili solo all&apos;agenzia titolare.
                                </p>
                            )}
                        </div>
                    </div>
                    <button data-testid="ai-actions-refresh" onClick={load} className="cta-outline px-3 py-2 text-xs flex items-center gap-2"><RefreshCw size={12} /> Aggiorna</button>
                </div>
                <div className="flex gap-1.5 mt-4 flex-wrap">
                    <button data-testid="ai-filter-all" onClick={() => setFilter("all")} className={`px-3 py-1.5 text-[11px] border transition-colors ${filter === "all" ? "border-gold text-gold bg-gold/5" : "border-white/15 text-ink-400 hover:border-white/30"}`}>Tutte</button>
                    {Object.entries(TYPE_META).map(([k, m]) => (
                        <button key={k} data-testid={`ai-filter-${k}`} onClick={() => setFilter(k)} className={`px-3 py-1.5 text-[11px] border transition-colors flex items-center gap-1.5 ${filter === k ? "border-gold text-gold bg-gold/5" : "border-white/15 text-ink-400 hover:border-white/30"}`}>
                            {m.icon} {m.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="border border-white/10">
                {items.length === 0 ? (
                    <p data-testid="ai-actions-empty" className="p-6 text-sm text-ink-400">Nessuna azione AI registrata{filter !== "all" ? " per questo filtro" : ""}. Le azioni compaiono qui quando le agenzie attivano l&apos;autonomia dell&apos;assistente.</p>
                ) : (
                    <div className="divide-y divide-white/5">
                        {items.map((a) => {
                            const m = TYPE_META[a.action_type] || { label: a.action_type, icon: <Bot size={13} />, cls: "border-white/15 text-ink-400 bg-black/30" };
                            return (
                                <div key={a.id} data-testid={`ai-action-row-${a.id}`} className="p-4 grid grid-cols-12 gap-3 items-center text-sm">
                                    <div className="col-span-2 text-xs text-ink-400">{new Date(a.created_at).toLocaleString("it-IT")}</div>
                                    <div className="col-span-2">
                                        <span className={`px-2 py-1 text-[10px] uppercase tracking-wider border inline-flex items-center gap-1.5 ${m.cls}`}>{m.icon} {m.label}</span>
                                    </div>
                                    <div className="col-span-5 text-xs text-ink-100">{a.detail}</div>
                                    <div className="col-span-3 text-right">
                                        <div className="text-xs text-ink-50">{a.agency_name || "—"}</div>
                                        <div className="text-[10px] text-ink-400 truncate">{a.target || a.agency_email}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
